/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AIToolAccessSummary,
  AIToolAccessSummary$inboundSchema,
} from "./aitoolaccesssummary.js";

export type SetAIToolDecisionResult = {
  /**
   * The enforcement verdict for one AI tool, computed server-side so a client renders wording without re-deriving it. state shares its vocabulary with the shadow MCP inventory's access summary, so one column describes both halves of the Shadow AI section.
   */
  access: AIToolAccessSummary;
  /**
   * The detection target the decision was recorded for.
   */
  targetId: string;
};

/** @internal */
export const SetAIToolDecisionResult$inboundSchema: z.ZodMiniType<
  SetAIToolDecisionResult,
  unknown
> = z.pipe(
  z.object({
    access: AIToolAccessSummary$inboundSchema,
    target_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "target_id": "targetId",
    });
  }),
);

export function setAIToolDecisionResultFromJSON(
  jsonString: string,
): SafeParseResult<SetAIToolDecisionResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SetAIToolDecisionResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SetAIToolDecisionResult' from JSON`,
  );
}
